import axios from 'axios';
import qs from 'qs';

export const uploadAttachment = async ({ token, file, dealId } = {}) => {

  const data = new FormData();
  data.append('file', file)

  try {
    const response = await axios({
      method: 'post',
      url: `${process.env.REACT_APP_API_URL}/attachments?${qs.stringify({ dealId })}`,
      headers: {
        Authorization: token,
        'Content-Type': 'multipart/form-data',
      },
      data
    });

    if (response instanceof Error) {
      return { error: response }
    }

    return response;

  } catch (error) {
    // Sentry TODO
    return { error };
  }
};

export const signedUrl = async ({ token, attachmentId } = {}) => {

  try {
    const response = await axios({
      method: 'get',
      url: `${process.env.REACT_APP_API_URL}/attachments/${attachmentId}/signedUrl`,
      headers: {
        Authorization: token,
      },
    });

    if (response instanceof Error) {
      return { error: response }
    }

    return response;

  } catch (error) {
    // Sentry TODO
    return { error };
  }
};

export const deleteAttachment = async ({ token, attachmentId } = {}) => {

  try {
    const response = await axios({
      method: 'delete',
      url: `${process.env.REACT_APP_API_URL}/attachments/${attachmentId}`,
      headers: {
        Authorization: token,
      },
    });

    if (response instanceof Error) {
      return { error: response }
    }

    return response;

  } catch (error) {
    // Sentry TODO
    return { error };
  }
};